import type { Feature, Point } from "geojson";
import type { MapObjectProperties } from "@iventis/map-types";
import type { BehaviorSubject } from "rxjs";
import { Status } from "@iventis/domain-model/model/status";
import { StyleType } from "@iventis/domain-model/model/styleType";
import { PointStyle } from "@iventis/domain-model/model/pointStyle";
import { createStaticStyleValue } from "@iventis/layer-style-helpers";
import { PointPitchAlignment } from "@iventis/domain-model/model/pointPitchAlignment";
import { LayerStorageScope, MapState } from "../../types/store-schema";
import type { DomainLayer } from "../../state/map.state.types";
import { Layer } from "./layer";
import { ViewByStatus } from "../../types/layer-view-by";
import { defaultPointStyle } from "../../utilities/default-style-values";
import { createCustomStyleZoomableValue } from "../../utilities/zoomable-values";

export abstract class ModelStandBaseLayer extends Layer<Feature<Point, MapObjectProperties>[], PointStyle> {
    public readonly layerId: string;

    protected readonly sourceId: string;

    protected readonly baseLayer: DomainLayer;

    constructor(state$: BehaviorSubject<MapState>, modelLayerId: string) {
        super(state$);
        this.layerId = `${modelLayerId}-model-stand-base`;
        this.sourceId = this.layerId;
        this.baseLayer = this.createBaseLayer();
    }

    private createBaseLayer(): DomainLayer {
        return {
            id: this.layerId,
            status: Status.Active,
            mapId: "",
            visible: true,
            locked: false,
            imported: false,
            name: "model stand base",
            styleType: StyleType.Point,
            areaStyle: undefined,
            lineStyle: undefined,
            pointStyle: {
                ...defaultPointStyle,
                colour: createStaticStyleValue("black"),
                opacity: createStaticStyleValue(1),
                pitchAlignment: createStaticStyleValue(PointPitchAlignment.Map),
                radius: createCustomStyleZoomableValue({ 24: 14, 22: 10, 20: 8, 18: 4, 17: 0 }),
                outline: createStaticStyleValue(true),
                outlineColour: createStaticStyleValue("white"),
                outlineWidth: createStaticStyleValue(2),
            },
            iconStyle: undefined,
            modelStyle: undefined,
            lineModelStyle: undefined,
            areaModelStyle: undefined,
            previewIconUrl: "",
            dataFields: [],
            tooltipDataFieldIds: [],
            createdByUserId: "",
            createdByUserName: "",
            createdAt: undefined,
            lastUpdatedByUserId: "",
            lastUpdatedByUserName: "",
            lastUpdatedAt: undefined,
            viewBy: ViewByStatus.OBJECT,
            source: this.sourceId,
            stamp: "",
            selected: false,
            storageScope: LayerStorageScope.LocalOnly,
            remote: false,
        };
    }
}
